export default __webpack_public_path__ + "static/media/banner.1bfbb3a6.png";